import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { finalize } from 'rxjs';
import { CommonDialogInfo } from 'src/app/interfaces/CommonDialogInfo.model';
import { ImageModel } from 'src/app/interfaces/Image.model';
import { MediaService } from 'src/app/services/general/media/media.service';
import { ProductsService } from 'src/app/services/general/products/products.service';
import { CommonConfirmDialogComponent } from '../common-confirm-dialog/common-confirm-dialog.component';
import { ShowImageComponent } from './show-image/show-image.component';
import { type } from 'os';

@Component({
  selector: 'app-image-upload-with-cropper',
  templateUrl: './image-upload-with-cropper.component.html',
  styleUrls: ['./image-upload-with-cropper.component.css']
})
export class ImageUploadWithCropperComponent implements OnInit {
  listOfFiles: any[] = [];

  constructor(
    private dialog: MatDialog,
    private mediaService: MediaService,
    private cdr:ChangeDetectorRef,
    private productsService: ProductsService,

  ) { }
  @Input() label = 'Choose Image';
  @Input() productId = null;
  @Input() Folder = '';
  @Input() onlineImage = '';
  @Input() isMultiple = false;
  @Input() onlineImages :ImageModel[] = [];
  @Input() showPrimarySelect = false;
  @Input() showDeleteBtn = true;
  @Input() useProductApi = false;
  @Output() croppedImageEvent = new EventEmitter<any>();
  @Output() imageUpload = new EventEmitter<ImageModel>();
  @Output() deleteOnlineImage = new EventEmitter<ImageModel>();
  @Output() multiImageUpload = new EventEmitter<ImageModel[]>();
  @Output() setAsPrimary = new EventEmitter<any>();
  @Output() setOnlineImageAsPrimary = new EventEmitter<any>();
  format='png'
  originalFileTypes: string[] = []; // Store original file types
  originalFileNames: string[] = []; // Store original file names
  ngOnInit(): void {
  }
  uploadLabel = 'Upload'
  multiImageChangedEvent = [];
  urlImages=[]
  multiCroppedImage = []
  imagesList : ImageModel[]=[]
  showAction = true;
  showSpinner = false;
  isUploaded = false;
  onDeleteOnilneImage(index){
    let deleteInfo: CommonDialogInfo = new CommonDialogInfo();
    deleteInfo.dialogHeader = "Image Product";
    deleteInfo.dialogDeleteMessage = "Image Delete Successfully";
    deleteInfo.dialogDescription = "Are Sure You Want To Delete This Image ?";
    this.dialog
      .open(CommonConfirmDialogComponent, {
        data: deleteInfo,
      })
      .afterClosed()
      .subscribe(value => {
        if (value?.isConfirmed) {
          this.deleteOnlineImage.emit(this.onlineImages[index]);
        }
      });
  }
  onDeleteUploadedImage(index){
    this.imagesList.splice(index,1);
    this.imagesList = [...this.imagesList];
    this.multiImageChangedEvent.splice(index,1);
    this.urlImages.splice(index,1);
    this.originalFileTypes.splice(index,1);
    this.originalFileNames.splice(index,1);
    this.multiImageChangedEvent=[...this.multiImageChangedEvent];
    this.urlImages=[...this.urlImages];
  }
  onShowCroppedImage(index) {
    this.dialog.open(ShowImageComponent, { data:this.urlImages[index] , width: "auto", height: "auto" })
  }

  fileChangeEvent(event: any): void {
    console.log(event)
     
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      var selectedFile = event.target.files[i];
      if (this.listOfFiles.indexOf(selectedFile.name) === -1) {
        this.multiImageChangedEvent.push(selectedFile);
        this.listOfFiles.push(selectedFile.name);

        // Save original file type and name
        const fileType = selectedFile.type || 'image/png'; // Default to PNG if type is missing
        const fileExtension = fileType.split('/')[1] || 'png';
        this.originalFileTypes.push(fileType);
        this.originalFileNames.push(selectedFile.name);
        
        var reader = new FileReader();
   
        reader.onload = (_event) => {
          this.urlImages.push(_event.target.result);
          console.log('---------------------', this.urlImages, reader.result);
          this.cdr.detectChanges();
        };
        reader.readAsDataURL(event.target.files[i]);
        
        this.imageLoaded(event);
      }
    }
  }

  imageCropped(event: ImageCroppedEvent,index) {
    
    if(this.multiCroppedImage.length<index){
      this.multiCroppedImage.push(''); 
   
    }else{
      this.multiCroppedImage[index] = event.base64;
    }
      this.showAction = true;
  }
  imageLoaded(event) {
    console.log("imageLoaded" , event.transformed?.target)
    /* show cropper */

    this.showSpinner = false;
    this.isUploaded = false;
    this.uploadLabel = 'Upload'
    this.onlineImage =''
    this.isMultiple ? this.label = 'Add another image' : null
    this.imagesList.push(new ImageModel())
    this.cdr.detectChanges()
  }
  cropperReady() {
    /* cropper ready */

  }
  loadImageFailed() {
    /* show message */
  }
  uploadImage(index) {
    this.showSpinner = true;
    this.imagesList[index].isLoading = true;
    this.imagesList[index].ImageAsBase64 =this.urlImages[index];

    // Get original file type and name
    const originalFileType = this.originalFileTypes[index] || 'image/png';
    const originalFileName = this.originalFileNames[index] || `image_${index}.png`;
    const fileExtension = originalFileType.split('/')[1] || 'png';
    const fileName = originalFileName.split('.')[0] + '.' + fileExtension;

    this.dataURLtoFile(this.urlImages[index], fileName, originalFileType).then(file => {
        console.log("file");
        console.log(file);

        // upload product image
        if(this.useProductApi && this.productId){
          this.productsService.Upload({
            UploadFiles: file,
            Type: 'Image',
            Folder: this.Folder,
            KeepFileName: false,
            productId :this.productId,
            isPrimary : this.imagesList[index].isPrimary
          }, 'UploadImage')
            .pipe(
              finalize(() => {
                this.showSpinner = false
                this.imagesList[index].isLoading = false;
              })
            )
            .subscribe(
              res => {
                console.log(res.body);
                if (res.body.succeeded) {
                  this.imagesList[index].imageUrl = res.body.data.image;
                  this.imagesList[index].id = res.body.data.id;
                  this.imagesList[index].isLoaded = true;
                  this.imagesList[index].uploadLabel = "Uploaded";
                  this.imagesList[index].productId= res.body.data.productId;
                  this.imagesList[index].isPrimary= res.body.data.isPrimary;
                  if(!this.isMultiple){
                    this.imageUpload.emit(this.imagesList[index])
                    console.log('1-',this.imagesList[index])
                  }
                  else {
                  this.multiImageUpload.emit(this.imagesList)
                  console.log('2-',this.imagesList)
                  }
                  this.cdr.detectChanges();
                }
              }
            )
        }else{
          // upload another image
          this.mediaService.Upload({
            UploadFiles: file,
            Type: 'Image',
            Folder: this.Folder,
            KeepFileName: false
          }, 'Upload')
            .pipe(
              finalize(() => {
                this.showSpinner = false
                this.imagesList[index].isLoading = false;
              })
            )
            .subscribe(
              res => {
                if (res.body.succeeded) {
                  this.imagesList[index].imageUrl = res.body.data.files[0];
                  this.imagesList[index].isLoaded = true;
                  this.imagesList[index].uploadLabel = "Uploaded";
                  this.imagesList[index].productId=null;
                  if(!this.isMultiple){
                    this.imageUpload.emit(this.imagesList[index])
                  }
                  else {
                  this.multiImageUpload.emit(this.imagesList)
                  }
                  this.cdr.detectChanges();
                }
              }
            )
        }
      })
  }
  setImageAsPrimary(index,status){ 
   this.imagesList.map(image=>{
     image.isPrimary=false;
    })
    this.imagesList[index].isPrimary = !status;

    if(this.onlineImages.length>0){
      let i  = this.onlineImages.findIndex(item=>item.isPrimary);
      this.onSetOnlineImageAsPrimary(i,this.onlineImages[i].isPrimary);  
    }
    // case set image as primary after uploaded
    if(this.imagesList[index]?.isLoaded){
      this.setAsPrimary.emit({index:index,status:status});
    }
  }
  
  onSetOnlineImageAsPrimary(index,status){ 

    this.setOnlineImageAsPrimary.emit({index:index,status:status});
  
  }
  
  dataURLtoFile(url, filename, mimeType?: string) {
    // Extract mime type from data URL if not provided
    if (!mimeType && url.startsWith('data:')) {
      const matches = url.match(/data:([^;]+);/);
      mimeType = matches ? matches[1] : 'image/png';
    }
    
    // Default to PNG if mime type is still not available
    if (!mimeType) {
      mimeType = 'image/png';
    }

    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }
  async b64toBlob(base64Data) {
    const base64Response = await fetch(base64Data);
    const blob = await base64Response.blob();
    return blob
  }
}
